import { Title } from "@rothoblaas/design-system";
import { FC, ReactNode } from "react";
import { useNavigate } from "react-router-dom";
import useI18n from "../../hooks/useTranslations";
import { CustomError, isForbidden, isNotFound } from "../../http/errors";

export interface HeaderPath {
  display: string;
  url?: string;
}

interface HeaderProps {
  title: string;
  path?: HeaderPath | HeaderPath[];
  buttons?: ReactNode | ReactNode[];
  error?: CustomError;
  accentColor?: string;
}

const Header: FC<HeaderProps> = ({ title, buttons, path, error, accentColor }: HeaderProps) => {
  const i18n = useI18n();
  const navigate = useNavigate();

  const errorText = isNotFound(error)
    ? i18n.translation.common.resourceNotFound
    : isForbidden(error)
      ? i18n.translation.common.youAreNotAllowed
      : error
        ? i18n.translation.common.genericError
        : undefined;

  const titleText = isNotFound(error)
    ? i18n.translation.common.notFound
    : isForbidden(error)
      ? i18n.translation.common.forbidden
      : error
        ? i18n.translation.common.error
        : title;

  return (
    <Title
      title={titleText}
      path={path}
      error={errorText}
      bar={{ accentColor }}
      onNavigate={(url) => navigate(url)}
      buttons={buttons}
    />
  );
};

export default Header;
